module.exports = __webpack_public_path__ + "img/video_TH-t.9b453747.png";